
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqjjKwHwl3gHPshJy6Fwl0mtVaKy4g6wmpINdRy4T3GwoMeta } from "/vercel/path0/pages/faq.vue?macro=true";
import { default as hotelcUIFUz09eCF3IdmR2PQqDEMm_cl2gYydm338FRaEUzgMeta } from "/vercel/path0/pages/hotel.vue?macro=true";
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as contact6cZoOGxJBTY9l_45DSf37OWQKprIBU1PffJx7PVn14dCsMeta } from "/vercel/path0/pages/contact.vue?macro=true";
import { default as galleryDLxFKVENimRRVJJ_459ELiRq_45VfjTVrdrzneLKnokQEnkMeta } from "/vercel/path0/pages/gallery.vue?macro=true";
import { default as privacyoUxJze_459YVMN19fHCMNcOPA4bNg1TjmwARd6j9aojjEMeta } from "/vercel/path0/pages/privacy.vue?macro=true";
import { default as reviewssJjJ9Q3KaOsW6OaQfQCHMlf7POWTAro7_mpjJ8HZ6i0Meta } from "/vercel/path0/pages/reviews.vue?macro=true";
import { default as sitemapnpadVI10GvN_45Y_45o1so1bwWJcyYretVyWs_xkYJE7aFUMeta } from "/vercel/path0/pages/sitemap.vue?macro=true";
import { default as _91_46_46_46page_93B6221gClypHIxjPWduJSW1WcqVmtTSAgv2lPPCKtC3oMeta } from "/vercel/path0/pages/[...page].vue?macro=true";
import { default as highlightsFtq_45vGp_5Sa6uu0A_45qfY5jjT_r_CTr7r70jkJpMRqc4Meta } from "/vercel/path0/pages/highlights.vue?macro=true";
import { default as indexna0DTdJ9MOcZDj_Pn7omZm8Tb_trwqDATTqect1_45xAIMeta } from "/vercel/path0/pages/news/index.vue?macro=true";
import { default as meetingformtuZG9J_45E28uJhtjKoToSNc7SkxNB_c_45orihlKcLBfEkMeta } from "/vercel/path0/pages/meetingform.vue?macro=true";
import { default as _91item_93gCoMJRgYbQ4LeChe2eMBYWADUR70hcy33O1I9onZxacMeta } from "/vercel/path0/pages/news/[item].vue?macro=true";
import { default as indexZdbeiSLGH5QVPn2J_weMTpHeymMl22S4LMxJcrOTUAEMeta } from "/vercel/path0/pages/rooms/index.vue?macro=true";
import { default as meetingroomsSvYyN2F1FmBVbJetjYyFYHq6F9i2JAJmDlDasZki2jkMeta } from "/vercel/path0/pages/meetingrooms.vue?macro=true";
import { default as _91item_93h1jfaZ0LMC4g7gWJiuxffsG7UnJguRUVyOO_45dojPxMIMeta } from "/vercel/path0/pages/rooms/[item].vue?macro=true";
import { default as indexZn_45bAcd39gGp3B0BjAFVKy86eJy9pe0_68j0ApHVaqMMeta } from "/vercel/path0/pages/packages/index.vue?macro=true";
import { default as _91item_939C8kULePuMOZkF6y8V95ZLVBcRP1Lk2y8Tk8ECdGARwMeta } from "/vercel/path0/pages/packages/[item].vue?macro=true";
import { default as slaapvisualisatie0t1XSd4uQeLYNXWLs1C5Ii497Glq_45hGGJTCatHTz7_UMeta } from "/vercel/path0/pages/slaapvisualisatie.vue?macro=true";
import { default as index27NtJibUesXU0_45gV9RjsyqxNyypQXjZQlLiHTmM8WPAMeta } from "/vercel/path0/pages/meetingpackages/index.vue?macro=true";
import { default as _91item_93jNm0OJHsrIKzLT_hoCtSwhUQWpBMFxpLCGiV3HpwjK0Meta } from "/vercel/path0/pages/meetingpackages/[item].vue?macro=true";
import { default as indexwE5YpF87QOtIwfM7DlgkiLqLgZGphSyC5QvqCQbb2PUMeta } from "/vercel/path0/pages/masterclass-packages/index.vue?macro=true";
import { default as _91item_93dJQFVw7rM1LsbPMkCy0mQtr_lwQgDoXofa8_45IxHRM2EMeta } from "/vercel/path0/pages/masterclass-packages/[item].vue?macro=true";
export default [
  {
    name: "faq___nl",
    path: "/faq",
    component: () => import("/vercel/path0/pages/faq.vue")
  },
  {
    name: "faq___en",
    path: "/en/faq",
    component: () => import("/vercel/path0/pages/faq.vue")
  },
  {
    name: "faq___de",
    path: "/de/faq",
    component: () => import("/vercel/path0/pages/faq.vue")
  },
  {
    name: "hotel___nl",
    path: "/hotel",
    component: () => import("/vercel/path0/pages/hotel.vue")
  },
  {
    name: "hotel___en",
    path: "/en/hotel",
    component: () => import("/vercel/path0/pages/hotel.vue")
  },
  {
    name: "hotel___de",
    path: "/de/hotel",
    component: () => import("/vercel/path0/pages/hotel.vue")
  },
  {
    name: "index___nl",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "contact___nl",
    path: "/contact",
    component: () => import("/vercel/path0/pages/contact.vue")
  },
  {
    name: "contact___en",
    path: "/en/contact",
    component: () => import("/vercel/path0/pages/contact.vue")
  },
  {
    name: "contact___de",
    path: "/de/kontakt",
    component: () => import("/vercel/path0/pages/contact.vue")
  },
  {
    name: "gallery___nl",
    path: "/galerij",
    component: () => import("/vercel/path0/pages/gallery.vue")
  },
  {
    name: "gallery___en",
    path: "/en/gallery",
    component: () => import("/vercel/path0/pages/gallery.vue")
  },
  {
    name: "gallery___de",
    path: "/de/galerie",
    component: () => import("/vercel/path0/pages/gallery.vue")
  },
  {
    name: "privacy___nl",
    path: "/cookiebeleid",
    component: () => import("/vercel/path0/pages/privacy.vue")
  },
  {
    name: "privacy___en",
    path: "/en/privacy-policy",
    component: () => import("/vercel/path0/pages/privacy.vue")
  },
  {
    name: "privacy___de",
    path: "/de/datenschutz",
    component: () => import("/vercel/path0/pages/privacy.vue")
  },
  {
    name: "reviews___nl",
    path: "/beoordelingen",
    component: () => import("/vercel/path0/pages/reviews.vue")
  },
  {
    name: "reviews___en",
    path: "/en/reviews",
    component: () => import("/vercel/path0/pages/reviews.vue")
  },
  {
    name: "reviews___de",
    path: "/de/rezensionen",
    component: () => import("/vercel/path0/pages/reviews.vue")
  },
  {
    name: "sitemap___nl",
    path: "/sitemap",
    component: () => import("/vercel/path0/pages/sitemap.vue")
  },
  {
    name: "sitemap___en",
    path: "/en/sitemap",
    component: () => import("/vercel/path0/pages/sitemap.vue")
  },
  {
    name: "sitemap___de",
    path: "/de/sitemap",
    component: () => import("/vercel/path0/pages/sitemap.vue")
  },
  {
    name: "page___nl",
    path: "/:page(.*)*",
    component: () => import("/vercel/path0/pages/[...page].vue")
  },
  {
    name: "page___en",
    path: "/en/:page(.*)*",
    component: () => import("/vercel/path0/pages/[...page].vue")
  },
  {
    name: "page___de",
    path: "/de/:page(.*)*",
    component: () => import("/vercel/path0/pages/[...page].vue")
  },
  {
    name: "highlights___nl",
    path: "/bezienswaardigheden",
    component: () => import("/vercel/path0/pages/highlights.vue")
  },
  {
    name: "highlights___en",
    path: "/en/highlights",
    component: () => import("/vercel/path0/pages/highlights.vue")
  },
  {
    name: "highlights___de",
    path: "/de/sehenswurdigkeiten",
    component: () => import("/vercel/path0/pages/highlights.vue")
  },
  {
    name: "news___nl",
    path: "/nieuws",
    component: () => import("/vercel/path0/pages/news/index.vue")
  },
  {
    name: "news___en",
    path: "/en/news",
    component: () => import("/vercel/path0/pages/news/index.vue")
  },
  {
    name: "news___de",
    path: "/de/nachrichten",
    component: () => import("/vercel/path0/pages/news/index.vue")
  },
  {
    name: "meetingform___nl",
    path: "/vergader-formulier",
    component: () => import("/vercel/path0/pages/meetingform.vue")
  },
  {
    name: "meetingform___en",
    path: "/en/meeting-form",
    component: () => import("/vercel/path0/pages/meetingform.vue")
  },
  {
    name: "meetingform___de",
    path: "/de/besprechungsformular",
    component: () => import("/vercel/path0/pages/meetingform.vue")
  },
  {
    name: "news-item___nl",
    path: "/nieuws/:item()",
    component: () => import("/vercel/path0/pages/news/[item].vue")
  },
  {
    name: "news-item___en",
    path: "/en/news/:item()",
    component: () => import("/vercel/path0/pages/news/[item].vue")
  },
  {
    name: "news-item___de",
    path: "/de/nachrichten/:item()",
    component: () => import("/vercel/path0/pages/news/[item].vue")
  },
  {
    name: "rooms___nl",
    path: "/kamers",
    component: () => import("/vercel/path0/pages/rooms/index.vue")
  },
  {
    name: "rooms___en",
    path: "/en/rooms",
    component: () => import("/vercel/path0/pages/rooms/index.vue")
  },
  {
    name: "rooms___de",
    path: "/de/zimmer",
    component: () => import("/vercel/path0/pages/rooms/index.vue")
  },
  {
    name: "meetingrooms___nl",
    path: "/vergaderzalen",
    component: () => import("/vercel/path0/pages/meetingrooms.vue")
  },
  {
    name: "meetingrooms___en",
    path: "/en/meeting-rooms",
    component: () => import("/vercel/path0/pages/meetingrooms.vue")
  },
  {
    name: "meetingrooms___de",
    path: "/de/tagungsraume",
    component: () => import("/vercel/path0/pages/meetingrooms.vue")
  },
  {
    name: "rooms-item___nl",
    path: "/kamers/:item()",
    component: () => import("/vercel/path0/pages/rooms/[item].vue")
  },
  {
    name: "rooms-item___en",
    path: "/en/rooms/:item()",
    component: () => import("/vercel/path0/pages/rooms/[item].vue")
  },
  {
    name: "rooms-item___de",
    path: "/de/zimmer/:item()",
    component: () => import("/vercel/path0/pages/rooms/[item].vue")
  },
  {
    name: "packages___nl",
    path: "/arrangementen",
    component: () => import("/vercel/path0/pages/packages/index.vue")
  },
  {
    name: "packages___en",
    path: "/en/special-offers",
    component: () => import("/vercel/path0/pages/packages/index.vue")
  },
  {
    name: "packages___de",
    path: "/de/arrangements",
    component: () => import("/vercel/path0/pages/packages/index.vue")
  },
  {
    name: "packages-item___nl",
    path: "/arrangementen/:item()",
    component: () => import("/vercel/path0/pages/packages/[item].vue")
  },
  {
    name: "packages-item___en",
    path: "/en/special-offers/:item()",
    component: () => import("/vercel/path0/pages/packages/[item].vue")
  },
  {
    name: "packages-item___de",
    path: "/de/arrangements/:item()",
    component: () => import("/vercel/path0/pages/packages/[item].vue")
  },
  {
    name: "slaapvisualisatie___nl",
    path: "/witte-berken-slaapvisualisatie-mijn-lievelingsplek",
    component: () => import("/vercel/path0/pages/slaapvisualisatie.vue")
  },
  {
    name: "slaapvisualisatie___en",
    path: "/en/witte-berken-slaapvisualisatie-mijn-lievelingsplek",
    component: () => import("/vercel/path0/pages/slaapvisualisatie.vue")
  },
  {
    name: "slaapvisualisatie___de",
    path: "/de/witte-berken-slaapvisualisatie-mijn-lievelingsplek",
    component: () => import("/vercel/path0/pages/slaapvisualisatie.vue")
  },
  {
    name: "meetingpackages___nl",
    path: "/vergader-arrangementen",
    component: () => import("/vercel/path0/pages/meetingpackages/index.vue")
  },
  {
    name: "meetingpackages___en",
    path: "/en/meeting-packages",
    component: () => import("/vercel/path0/pages/meetingpackages/index.vue")
  },
  {
    name: "meetingpackages___de",
    path: "/de/tagungspakete",
    component: () => import("/vercel/path0/pages/meetingpackages/index.vue")
  },
  {
    name: "meetingpackages-item___nl",
    path: "/vergader-arrangementen/:item()",
    component: () => import("/vercel/path0/pages/meetingpackages/[item].vue")
  },
  {
    name: "meetingpackages-item___en",
    path: "/en/meeting-packages/:item()",
    component: () => import("/vercel/path0/pages/meetingpackages/[item].vue")
  },
  {
    name: "meetingpackages-item___de",
    path: "/de/tagungspakete/:item()",
    component: () => import("/vercel/path0/pages/meetingpackages/[item].vue")
  },
  {
    name: "masterclass-packages___nl",
    path: "/masterclass-arrangementen",
    component: () => import("/vercel/path0/pages/masterclass-packages/index.vue")
  },
  {
    name: "masterclass-packages___en",
    path: "/en/special-offers",
    component: () => import("/vercel/path0/pages/masterclass-packages/index.vue")
  },
  {
    name: "masterclass-packages___de",
    path: "/de/arrangements",
    component: () => import("/vercel/path0/pages/masterclass-packages/index.vue")
  },
  {
    name: "masterclass-packages-item___nl",
    path: "/masterclass-arrangementen/:item()",
    component: () => import("/vercel/path0/pages/masterclass-packages/[item].vue")
  },
  {
    name: "masterclass-packages-item___en",
    path: "/en/special-offers/:item()",
    component: () => import("/vercel/path0/pages/masterclass-packages/[item].vue")
  },
  {
    name: "masterclass-packages-item___de",
    path: "/de/arrangements/:item()",
    component: () => import("/vercel/path0/pages/masterclass-packages/[item].vue")
  }
]